import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field, change } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { Loading } from './../../../components/includes/loading';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Upload } from './../../../components/includes/upload';
import { Ttolbar } from './../../../components/includes/ui/table';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn } from './../../../components/includes/ui';
import { BannersService } from './../../../services';

import VALIDATION from './../../../config/validation';

const validate = values => {

  const errors = {}

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (values.disposition === '-1') {
    errors.disposition = VALIDATION.required;
  }

  if (values.target === '-1') {
    errors.target = VALIDATION.required;
  }

  if (!values.name) {
    errors.name = VALIDATION.required;
  }else if(values.name.length > 255){
    errors.name = 'El tamaño máximo es de 255 caracteres.';
  }

  return errors

};

class BannerUpdate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      id: null,
      loading: false,
      sending: false
    };
  }

  componentDidMount(){

    this._Find(this.props.match.params.id);

  }

  /*
  ** @Service
  ** @Description: Find
  */

  _Find = (id) => {

    BannersService.find(id).then((response) => {

      // @State
      this.setState({ loading: true, id: id });

      // @Dispatch
      this.props.Update(response);

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  /*
  ** @Service
  ** @Description: Update
  */

  _Update = (values) => {

    // @Loading
    this.setState({ loading: false });

    // @Service
    BannersService.update(this.state.id, values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/banners');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exitio, el banner fue editado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  /*
  ** @Event
  ** @Description: Submit button
  */

  handleSubmitForm = (values) => {
    this._Update(values);
  }

  /*
  ** @Service
  ** @Description: Attachments
  */

  onUploadImagenLarge = (file) => {
    this.props.dispatch(change('BannerUpdate', 'image_large', file.attachment[0] ));
  }

  render() {

    const { loading, sending } = this.state;
    const { BannerUpdate, handleSubmit, invalid } = this.props;
    
    return (
      <Section>
        <ToolbarPrimary title="Banners"/>
        <BreadcrumbItem to='/banners'>Banners</BreadcrumbItem>
        <BreadcrumbItem to='/banners/update'>Editar</BreadcrumbItem>
        <Content>

          <Main>

            { loading ? (

              <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

                <Ttolbar title="Edición de banner"/>

                <FormContent enabledActions>

                  <Grid container spacing={24}>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Field
                          name="name"
                          component={ InputTextField }
                          label="Nombre"
                          type="text"
                          required
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Field
                          name="status"
                          component={ SelectField }
                          label="Estado" required>
                            <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                            <OptionField key="true" value="true">Activo</OptionField>
                            <OptionField key="false" value="false">Bloqueado</OptionField>
                      </Field>
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Field
                          name="link_url"
                          component={ InputTextField }
                          label="Enlace"
                          type="text"
                      />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Field
                          name="link_target"
                          component={ SelectField }
                          label="Apertura">
                            <OptionField key="_self" value="_self">Misma Página</OptionField>
                            <OptionField key="_blank" value="_blank">Nueva Página</OptionField>
                      </Field>
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Field
                          name="image_large"
                          type="hidden"
                          component={ InputTextField }
                      />
                      <Upload
                        button="Subir imagen"
                        file={ BannerUpdate.image_large }
                        onSuccess={ this.onUploadImagenLarge.bind(this) }
                      />
                    </Grid>

                  </Grid>

                </FormContent>

                <FormActions>
                  <Grid container>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Buttons>
                        <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/banners">
                          Volver
                        </Btn>
                      </Buttons>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Buttons align="right">
                        <Btn aria-label="Guardar banner" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                          Guardar banner
                        </Btn>
                      </Buttons>
                    </Grid>
                  </Grid>
                </FormActions>

              </form>

            ) : (
              <Loading variant="primary"/>
            )}

          </Main>

        </Content>
      </Section>
    )
  }
}

BannerUpdate = reduxForm({
  form: 'BannerUpdate',
  validate,
  enableReinitialize: true
})(BannerUpdate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert,
    BannerUpdate: state.BannerUpdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
    Update: (data) => {
      dispatch({
        type: 'BANNER_UPDATE',
        data: data
      });
    }
  }
}

BannerUpdate = connect(
  state => ({
    initialValues: {
      name: state.BannerUpdate.name,
      status: state.BannerUpdate.status,
      link_url: state.BannerUpdate.link_url,
      link_target: state.BannerUpdate.link_target ? state.BannerUpdate.link_target : '_self'
    }
  })
)(BannerUpdate);

export default connect(mapStateToProps, mapDispatchToProps)(BannerUpdate);
